import { render, staticRenderFns } from "./drawConfig.vue?vue&type=template&id=ff490d90&scoped=true"
import script from "./drawConfig.vue?vue&type=script&lang=js"
export * from "./drawConfig.vue?vue&type=script&lang=js"
import style0 from "./drawConfig.vue?vue&type=style&index=0&id=ff490d90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff490d90",
  null
  
)

export default component.exports